import { isChannelViewVar } from './useOverlayProps';
import { useCallback } from 'react';
import { makeVar, useReactiveVar } from '@apollo/client';

const isPlayingVar = makeVar<boolean>(false);

export function usePlayback() {
  const playing = useReactiveVar(isPlayingVar);

  const play = useCallback(() => {
    isChannelViewVar(false);
    isPlayingVar(true);
  }, []);

  const pause = useCallback(() => isPlayingVar(false), []);

  return {
    play,
    pause,
    playing,
  };
}
